'use strict';

module.exports = require('./ReactRevealText').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-reveal-text/lib/index.js
// module id = 414
// module chunks = 114276838955818